import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import PropTypes from 'prop-types';

import EmptyListing from 'src/components/EmptyListing/EmptyListing';
import ActionLink from 'src/components/EmptyListing/ActionLink';
import ListingImage from 'src/components/EmptyListing/ListingImage';


// eslint-disable-next-line max-lines-per-function
const NoSaved = function ({ isLoggedIn }) {
  const {
    noSavedDesktopImage,
    noSavedMobileImage,
    noLoggedSavedDesktopImage,
    noLoggedSavedMobileImage
  } = useSelector(
    ({ imagesReducer }) => ({
      noSavedDesktopImage: imagesReducer.noSavedDesktop,
      noSavedMobileImage: imagesReducer.noSavedMobile,
      noLoggedSavedDesktopImage: imagesReducer.noLoggedSavedDesktop,
      noLoggedSavedMobileImage: imagesReducer.noLoggedSavedMobile
    }),
    shallowEqual
  );
  const { searchFilterURL, loginURL } = useSelector(
    ({ configReducer }) => ({
      searchFilterURL: configReducer.searchFilterURL,
      loginURL: configReducer.loginURL
    }),
    shallowEqual
  );
  const emptyListingProperties = isLoggedIn ? {
    footer: (
      <ActionLink
        dataTest="anchor-search"
        href={ searchFilterURL }
        label="Zacznij szukać"
      />
    ),
    header: 'Dodaj interesujące Cię oferty do zapisanych',
    image: (
      <ListingImage
        desktop={ noSavedDesktopImage }
        mobile={ noSavedMobileImage }
      />
    )
  } : {
    footer: (
      <ActionLink
        dataTest="anchor-logIn"
        href={ loginURL }
        label="Zaloguj się"
      />
    ),
    header: 'Zaloguj się, aby zobaczyć zapisane oferty',
    image: (
      <ListingImage
        desktop={ noLoggedSavedDesktopImage }
        mobile={ noLoggedSavedMobileImage }
      />
    )
  };

  return <EmptyListing { ...emptyListingProperties } />;
};

NoSaved.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired
};

export default NoSaved;
